import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { Team } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 2260. メニュー掲載チーム一覧
 * [GET] /workspaces/:identifier/me/menu_listed_teams
 */
type Props = {
  identifier: string;
};

type MenuListedTeamsResponse = {
  sales_order_teams: Team[];
  purchase_order_teams: Team[];
};

const menuListedTeams = (props: Props): Promise<MenuListedTeamsResponse> => {
  return axios.get(`/api/workspaces/${props.identifier}/me/menu_listed_teams`, { params: props });
};

export const useMenuListedTeams = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'teams', 'menu_listed_teams'],
    queryFn: () => menuListedTeams(props),
  });
};
